import _ from 'lodash';
import { required, requiredIf } from 'vuelidate/lib/validators';

const adjustmentSelections = [
  'given the current environment, the trustee expects there are considerable financial risks involved in attempting to find a new tenant at this time',
  'over the longer term, the trustee expects the tenant to return to normal trading conditions and at that time continue to provide a strong return for the fund',
  [
    {
      codeApplies: true,
      description: 'the trustee is required to consider the requirements of the National Cabinet\'s Mandatory Code of Conduct - Commercial Leasing Principles which suggests that some rent relief is appropriate as part of good faith negotiations between the parties ',
    },
    {
      codeApplies: false,
      description: 'while the trustee is not specifically required to follow the requirements of the National Cabinet\'s Mandatory Code of Conduct - Commercial Leasing Principles, the Code establishes some broad principles for good faith negotiations at the current time which the trustee believes it would be appropriate to consider',
    },
  ],
  'other',
];

export default {
  name: 'rent-relief-adjustments',
  computed: {
    codeApplies() {
      // return this.$store.getters['rentRelief/getDetermination].codeApplies;
      return true;
    },
    adjustmentSelections() {
      return adjustmentSelections.map((selection) => {
        if (_.isArray(selection)) {
          return selection.find(item => item.codeApplies === this.codeApplies).description;
        }
        return selection;
      });
    },
    adjustmentSelection: {
      get() {
        return this.$store.getters['toolkit/getItemData'].adjustments.adjustments.adjustments;
      },
      set(value) {
        const adjustments = {
          adjustments: {
            adjustments: {
              adjustments: value,
            },
          },
        };

        if (!value.includes('other')) {
          adjustments.adjustments.adjustments.other = '';
        }
        this.$store.dispatch('toolkit/updateItemKey', { data: adjustments });
      },
    },
    other: {
      get() {
        return this.$store.getters['toolkit/getItemData'].adjustments.adjustments.other;
      },
      set(value) {
        this.$store.dispatch('toolkit/updateItemKey', { data: { adjustments: { adjustments: { other: value } } } });
      },
    },
  },
  methods: {
    handleBackStep() {
      this.$emit('backStep');
    },
    handleNextStep() {
      this.$emit('nextStep');
    },
  },
  validations: {
    adjustmentSelection: {
      required,
    },
    other:
      {
        required: requiredIf(function otherRequired() {
          if (this.adjustmentSelection.findIndex(value => value === 'other') >= 0) {
            return true;
          }
          return false;
        }),
      },
  },
};
